import {
  Beef,
  Salad,
  CupSoda,
  IceCreamCone,
  Sparkles,
  Pizza,
  Fish,
  Egg,
  Cake,
  Coffee,
  Wine,
  Apple,
  Cherry,
  Sandwich,
  Soup,
  Utensils,
  Cookie,
  Croissant,
  Drumstick,
  Milk,
  Popcorn,
  Bean,
  Carrot,
  Citrus,
  Grape,
  Nut,
  Wheat,
  Candy,
  Layers,
  ShoppingBag,
  Flame,
  Leaf,
  Heart,
  Star,
  Zap,
  Gift,
  Crown,
  Package,
} from 'lucide-react';

/**
 * Map of icon name → Lucide component.
 * Used across CategoryBar, admin category list, and modals.
 */
export const CATEGORY_ICON_MAP = {
  Beef,
  Salad,
  CupSoda,
  IceCreamCone,
  Sparkles,
  Pizza,
  Fish,
  Egg,
  Cake,
  Coffee,
  Wine,
  Apple,
  Cherry,
  Sandwich,
  Soup,
  Utensils,
  Cookie,
  Croissant,
  Drumstick,
  Milk,
  Popcorn,
  Bean,
  Carrot,
  Citrus,
  Grape,
  Nut,
  Wheat,
  Candy,
  Layers,
  ShoppingBag,
  Flame,
  Leaf,
  Heart,
  Star,
  Zap,
  Gift,
  Crown,
  Package,
};

/**
 * Curated list for the icon picker — grouped by type.
 */
export const ICON_PICKER_OPTIONS = [
  { group: 'Food', icons: ['Beef', 'Pizza', 'Sandwich', 'Drumstick', 'Fish', 'Egg', 'Soup', 'Croissant', 'Cookie', 'Popcorn'] },
  { group: 'Sides & Veggies', icons: ['Salad', 'Carrot', 'Bean', 'Wheat', 'Nut', 'Leaf'] },
  { group: 'Drinks', icons: ['CupSoda', 'Coffee', 'Wine', 'Milk'] },
  { group: 'Desserts & Sweets', icons: ['IceCreamCone', 'Cake', 'Candy'] },
  { group: 'Fruits', icons: ['Apple', 'Cherry', 'Citrus', 'Grape'] },
  { group: 'General', icons: ['Sparkles', 'Utensils', 'Flame', 'Heart', 'Star', 'Zap', 'Gift', 'Crown', 'ShoppingBag', 'Package', 'Layers'] },
];

/**
 * Get the Lucide component for a given icon name.
 * Falls back to Sparkles if not found.
 */
export function getCategoryIcon(iconName) {
  return CATEGORY_ICON_MAP[iconName] || Sparkles;
}

/**
 * Human-readable label for an icon name.
 * Converts camelCase → spaced words (e.g. "IceCreamCone" → "Ice Cream Cone").
 */
export function iconLabel(name) {
  return name.replace(/([A-Z])/g, ' $1').trim();
}
